import { AdditionalInfoModal } from './AdditionalInfoModal';

export default AdditionalInfoModal;
